<template>
	<el-tooltip popper-class="tq-custom-tooltip" :content="props.content" placement="top" :visible="visible">
		<div :style="{ '--direction': direction, cursor:pointerFlag? 'pointer': visible ? 'pointer' : 'auto' }"
			:class="`custom-tooltip-content-${direction} custom-tooltip-content${index}`" @mouseenter="onMouseOver()"
			@mouseleave="visible = false">
			{{ props.content }}
		</div>
	</el-tooltip>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { ElTooltip } from "element-plus";
const visible = ref(false);
const props = defineProps({
	content: { type: String, required: true, default: "" },
	index: { type: String, required: true, default: "0" },
	pointerFlag: { type: Boolean, default: false },
	direction: { type: String, required: false, default: "ltr" }, //rtl
});

const onMouseOver = () => {
	const contentElement = document.querySelector(".custom-tooltip-content" + props.index);
	if (contentElement) {
		visible.value = contentElement.scrollWidth > contentElement.clientWidth;
	}
};
defineOptions({
	name: "TqCustomTooltip"
})
</script>
<style>
.el-popper.tq-custom-tooltip {
    position: absolute !important;
}
</style>
<style lang="stylus" scoped>
.custom-tooltip-content-ltr {
  white-space: nowrap;
	word-break: break-all;
	text-overflow: ellipsis;
	display: block;
	/* 这里是超出几行省略 */
	overflow: hidden;
	/* 文本从右向左排列 */
	text-align: left;
}
.custom-tooltip-content-rtl{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    direction: rtl;
    text-align: left;
}
</style>
